// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"Tags_loadingOverlay__h7AGr"};